module.exports = __webpack_public_path__ + "static/media/jean-grey-win.ebacd138.png";